/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
import { ActionTypesCommon, ClassRemoteDataStore, DataNames, RemoteDataStore } from 'plugin/liferay-widgets-react-web';
import { ClassNames } from '../constants/Constants';
import FliwasOrganizationWebApi from '../webapi/FliwasOrganizationWebApi';

export default class FliwasOrganizationStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.Group, FliwasOrganizationWebApi.list, FliwasOrganizationWebApi.getByGroupId);
    }

    reduce(state, action) {
        switch (action.type) {

            case ActionTypesCommon.PAGE_SELECTED:
                if (this.className == action.meta.className) {
                    return this.initItem(state, DataNames.PAGE_SELECTED, action.payload, this.defaultItemData);
                } else {
                    return this.removeRemoteData(state, DataNames.PAGE_SELECTED);
                }
        }

        return super.reduce(state, action);
    }

    extendedWebsocketModelUpdate(remote, wsUpdate) {

        let newRemote;
        if (wsUpdate.content && wsUpdate.content.className === ClassNames.Organization) {
            const storeRemoteEntries = RemoteDataStore.remoteStatetoDataArray(remote);
            if (storeRemoteEntries && storeRemoteEntries.length > 0) {
                storeRemoteEntries.forEach(remoteEntry => {
                    if (remoteEntry.item) {
                        let newItem = RemoteDataStore.invalidateData(remoteEntry);
                        if (!newRemote) {
                            newRemote = (newRemote || (newRemote = { ...remote }));
                        }
                        newRemote[remoteEntry.name] = newItem;

                    }
                });
            }
        }
        return newRemote || remote;
    }

}



// WEBPACK FOOTER //
// ./js/stores/FliwasOrganizationStore.js